module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6AcUl"))).then(() => module.bundle.root('ikE14'));